<script setup>
</script>

<template>
    <div class="flex row items-end">
        <slot />
    </div>
</template>
